import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useHistory } from "react-router-dom";
import {
  getNewsletterMaterial,
  globalStatistic,
} from "../redux/actions/otherActions";

import PageBanner from "../components/banner/PageBanner";
import NewsletterItem from "../components/other/NewsletterItem";
import PageHelmet from "../components/helmet/PageHelmet";
import { getPageSeo } from "../redux/actions/pageActions";
import { useTranslation } from "react-i18next";

const OzonHubCategory = () => {
  const dispatch = useDispatch();
  const { category } = useParams();
  const getNewsletterMaterialItems = useSelector(
    (state) => state.getNewsletterMaterialItems.items,
  );
  const queries = useMediaQuery("(min-width: 2000px)");
  const queries1 = useMediaQuery("(max-width: 1024px)");
  const [pageSeoData, setPageSeoData] = useState({});
  const { t } = useTranslation("newsletterPage");
  var history = useHistory();

  useEffect(() => {
    dispatch(getPageSeo(1250)).then((res) => {
      if (res) {
        setPageSeoData(res);
      }
    });
    dispatch(getNewsletterMaterial(category));
    dispatch(globalStatistic(1250, "PAGE"));
  }, []);

  return (
    <>
      {Object.keys(pageSeoData).length !== 0 && (
        <PageHelmet
          title={pageSeoData ? `${pageSeoData.acSeoTitle}` : "Ewe Comp"}
          description={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
          keywords={pageSeoData ? `${pageSeoData.acSeoKeywords}` : ""}
          ogDescription={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
          ogTitle={pageSeoData ? `${pageSeoData.acSeoTitle}` : ""}
          ogUrl={pageSeoData ? `https://ewe.rs/${pageSeoData.acSeoUrl}` : ""}
          ogImg="https://www.ewe.rs/media/ewe-og-img.jpg"
          twitterDescription={
            pageSeoData ? `${pageSeoData.acSeoDescription}` : ""
          }
        />
      )}
      <div className="container-content container-main-content newsletter-content top-margin-navbar-escape">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="banner-image-on-top-page">
                <PageBanner categoryType="" categoryId="" pageId="1250" />
              </div>

              <div className="stats-order-content-holder">
                <h1>{category ? category : "Ostavite utisak uz našu pomoć"}</h1>
                {/* {pageSeoData.acSeoShortPageDescription && (
                  <p>{pageSeoData.acSeoShortPageDescription}</p>
                )} */}
              </div>
              <div className="contact-desc">{t("ozonDesc")}</div>
            </div>
            <button className="back-to-button" onClick={() => history.goBack()}>
              <img
                src="https://resource.ewe.rs/media/ikonice/Strelica.png"
                alt="back"
                className="back-icon"
              />
              &nbsp;&nbsp;{t("homePageLogout:nazad")}
            </button>

            <div className="col-sm-12">
              <div className="row">
                {getNewsletterMaterialItems.map((item, key) => (
                  <div
                    key={key}
                    className={
                      queries ? "col-sm-2" : queries1 ? "col-sm-4" : "col-sm-3"
                    }
                  >
                    <NewsletterItem item={item} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OzonHubCategory;
